import React, { Fragment, useEffect, useState } from "react";
import InformeAuto from "./InformeAuto";
import InformeEvluador from "./InformeEvaluador";

function InformeFinal() {
  return (
    <div>
      <InformeAuto />
      <InformeEvluador />
    </div>
  );
}
export default InformeFinal;
